import { TextFieldProps } from '@material-ui/core'
import { TargetPriceSlider } from 'components/ProjectPage/BillOfMaterials/Rows/TargetPrice/TargetPriceSlider'
import { saveBomItemTargetPrice } from 'features/BillOfMaterials/store/asyncActions/saveBomItemTargetPrice'
import { ProjectTextField } from 'features/BillOfMaterials/store/components/ProjectTextField'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { MoneyDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export function BomItemTargetPriceInput(props: {
  bomItemId: string
  priceScope?: 'perUnit' | 'total'
  textFieldProps?: TextFieldProps
  disableSlider?: boolean
  sliderClassName?: string
}) {
  const { t } = useTranslation()

  const targetPrice: MoneyDto = useAppSelector(
    projectSelectors.bomItemFinancialSelector(
      props.bomItemId,
      'targetSalesPricePerItem'
    ),
    isEqual
  ) as MoneyDto
  const salesPrice: MoneyDto = useAppSelector(
    projectSelectors.bomItemFinancialSelector(
      props.bomItemId,
      'salesPricePerItem'
    ),
    isEqual
  ) as MoneyDto

  // if (props.priceScope === 'total') {
  //   return (
  //     <ValueLabelConnected
  //       propertySelector={(state) =>
  //         MoneyString(
  //           projectSelectors.bomItemTargetPriceSelector(
  //             props.bomItemId,
  //             props.priceScope
  //           )(state)
  //         )
  //       }
  //       valueLabelProps={{
  //         label: t('common:target-price', 'target price'),
  //       }}
  //     />
  //   )
  // }

  return (
    <>
      <ProjectTextField
        valueSelector={projectSelectors.bomItemFinancialSelector(
          props.bomItemId,
          'targetSalesPricePerItem'
        )}
        textFieldProps={{
          label: t('common:target-price-per-batch', 'target price / batch'),
          ...props.textFieldProps,
        }}
        actionTypePrefix={saveBomItemTargetPrice.typePrefix.concat(
          '/',
          props.bomItemId
        )}
        saveAction={(value: MoneyDto) =>
          saveBomItemTargetPrice({
            bomItemId: props.bomItemId,
            targetPrice: value,
          })
        }
        money
      />
      {!props.disableSlider &&
        targetPrice?.value > 0 &&
        salesPrice?.value > 0 && (
          <TargetPriceSlider
            salesPrice={salesPrice}
            targetPrice={targetPrice}
            rootClassName={props.sliderClassName}
          />
        )}
    </>
  )
}
